import { formatMoney } from "@/components/restaurant/finance/constants";
import { contractStatusLabel } from "@/utils/contractStatus";

const KIND_TONES = { expired: "bad", expiring: "warn", valid: "ok", other: "plain", none: "plain" };
const PENDING_TONES = { missing: "bad", contract_expired: "bad", no_amount: "warn", contract_expiring: "warn", unverified: "blue", ok: "ok", other: "plain" };
const CARD_TONES = { expired: "bad", expiring: "warn", none: "muted" };

/**
 * Tekstovi stranice Ugovori. Nazivi restorana, statusi i vrste naplate dolaze sa servera u pismu u kojem su u bazi
 * (restorani ćirilicom, usluge latinicom), pa idu kroz toLatin: prikaz prati pismo izabranog jezika (spec: "presloviti pri prikazu").
 * Dijelovi ekrana (koji injektuju reportShell) i sama ljuska dijele isti rječnik.
 */
export default {
  methods: {
    restaurantLabel(name) {
      return this.toLatin(name || "");
    },
    initialsOf(name) {
      const letters = this.toLatin(name || "")
        .split(/\s+/)
        .map((word) => (word.match(/[\p{L}\p{N}]/u) || [""])[0])
        .filter(Boolean);
      return (letters[0] || "").concat(letters[1] || "").toUpperCase() || "?";
    },
    kindTone(kind) {
      return KIND_TONES[kind] || "plain";
    },
    cardTone(kind) {
      return CARD_TONES[kind] || "";
    },
    /** "istekao prije 42 dana" / "ističe za 12 dana" / "Važi" / "Bez roka", a za restoran bez ugovora "Nema ugovora" */
    statusText(row) {
      if (!row.hasContract) return this.$t("contracts_shell.row.none");
      return this.toLatin(contractStatusLabel(row.raw, this.$t.bind(this)));
    },
    /** "01.09.2026. – 31.08.2027." ili "01.09.2026. – bez roka"; bez početka samo "DO 31.08.2027." */
    periodText(from, to) {
      if (!from && !to) return "";
      if (!from) return `${this.$t("until")} ${this.localeDate(to)}`;
      return `${this.localeDate(from)} – ${to ? this.localeDate(to) : this.$t("contract_no_end_date_short")}`;
    },
    pendingTone(group) {
      return PENDING_TONES[group] || "plain";
    },
    pendingText(row) {
      const key = `contracts_shell.pending.${row.group}`;
      return this.$te(key) ? this.$t(key) : this.toLatin(row.status);
    },
    /** "restoran" / "trgovina" sa servera; sve što ne prepoznamo ispisuje se kakvo je stiglo */
    typeLabel(kind) {
      if (!kind) return "—";
      if (kind.startsWith("restor")) return this.$t("restaurant");
      if (/^(trgov|prodav|shop|store)/.test(kind)) return this.$t("shop");
      return this.toLatin(kind);
    },
    payTypeLabel(type) {
      return type ? this.$t(`contracts_shell.pay.${type}`) : "";
    },
    /** cijena iz radnog spiska: backendov `opis` kad stigne, inače iznos sa jedinicom ("10,00 %", "2,00 KM") i vrsta naplate ispod */
    priceParts(row) {
      if (row.opis) return { amount: this.toLatin(row.opis), label: "" };
      const label = row.payType ? this.payTypeLabel(row.payType) : this.toLatin(row.payWord);
      if (row.amount === null || Number.isNaN(row.amount)) return { amount: "", label };
      const unit = row.payType === 2 ? "%" : this.getCurrencyByRestaurantId(row.restaurantId) || "KM";
      return { amount: `${formatMoney(row.amount, "")} ${unit}`.trim(), label };
    },
  },
};
